import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2, Plane } from "lucide-react";
import Reveal from "./Reveal";

const CARDS = [
  {
    to: "/firmenkunden",
    icon: Building2,
    kicker: "Geschäftskunden",
    title: "Für Firmen & Unternehmen",
    desc: "Sammelrechnung, feste Konditionen und persönliche Betreuung für Ihre Geschäftstransfers.",
    img: "https://images.unsplash.com/photo-1752159400890-d906038f1b35?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    testid: "b2b-firmen-card",
  },
  {
    to: "/reisebuero",
    icon: Plane,
    kicker: "Reisebüros",
    title: "Für Reisebüros & Veranstalter",
    desc: "Attraktive Agenturkonditionen, White-Label Vouchers und Gruppentransfers in der ganzen Schweiz.",
    img: "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    testid: "b2b-reise-card",
  },
];

const B2B = () => {
  return (
    <section id="b2b" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <Reveal className="max-w-xl mb-12">
          <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">Partner & Business</p>
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] leading-[1.05]">Massgeschneiderte Lösungen für Partner.</h2>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.to} delay={i * 100}>
              <Link to={c.to} data-testid={c.testid} className="group relative flex flex-col justify-end h-80 rounded-[28px] overflow-hidden border border-[#E9E5DE]">
                <img src={c.img} alt={c.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1533] via-[#0B1533]/60 to-transparent" />
                <div className="relative p-8 text-white">
                  <span className="inline-flex items-center gap-2 font-body text-xs font-semibold text-[#C9A24B] mb-2"><c.icon size={16} /> {c.kicker}</span>
                  <h3 className="font-heading font-bold text-2xl sm:text-3xl">{c.title}</h3>
                  <p className="font-body text-sm text-white/70 mt-2 max-w-md">{c.desc}</p>
                  <span className="inline-flex items-center gap-2 font-body font-semibold text-white mt-4 group-hover:gap-3 transition-all">Mehr erfahren <ArrowRight size={16} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default B2B;
